import { autoinject, bindable } from "aurelia-framework";
import { UserClientService } from "../../../services/authentication/user-client.service";
import { GoogleAnalyticsService } from '@rightship-tech/common-ui/services/analytics/google-analytics.service';
import * as moment from "moment";
import { EventAggregator } from "aurelia-event-aggregator";
import { Messages } from "../../../configuration/event-messages.constants";

@autoinject
export class CompBannerVhc {

    @bindable
    hasCompletedVesselHealthCheck: boolean;
    
    @bindable
    lastVhcPerformedDate: Date;
    
    @bindable
    docCompany: string;
    
    @bindable
    customerType: string;

    constructor(private userClientService: UserClientService,
        private googleAnalyticsService: GoogleAnalyticsService,
        private eventAggregator: EventAggregator) { 

    }

    requestNow(){
        this.eventAggregator.publish(Messages.requestNowVHCBadgeClick);

        //Tracking VHC requests for Google Analytics - DEL-13959
        const timestamp = moment(new Date()).format('DD MMM YYYY HH:mm');

        this.googleAnalyticsService.sendCustomGA4EventMulti('vhc_request_now', {
            "userName": this.userClientService.currentUser?.userName,
            "userEmail": this.userClientService.currentUser?.email,
            "companyName": this.docCompany,//this.vessel.docCompanyName,
            "customerType": this.customerType,
            "timestamp": timestamp
        });
    }
}
